import { Skeleton } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { InvoiceFragmentGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { Typography } from 'packages/common-frontend/components/Typography';
import { useGetInvoiceDisbursementsByInvoiceIdQuery } from 'packages/invoices/requests/invoices.gql.generated';
import { InvoiceDisbursementsTable } from 'packages/invoices/ui/disbursements/InvoiceDisbursementsTable';

export const InvoiceDisbursements = ({
  invoice,
}: {
  invoice: InvoiceFragmentGQLType;
}) => {
  const {
    data: invoiceDisbursementsData,
    loading: isInvoiceDisbursementsLoading,
  } = useGetInvoiceDisbursementsByInvoiceIdQuery({
    variables: { invoiceId: invoice.id },
    fetchPolicy: 'network-only',
  });

  if (isInvoiceDisbursementsLoading || !invoiceDisbursementsData) {
    return <Skeleton height="200px" />;
  }

  if (
    invoiceDisbursementsData.getInvoiceDisbursementsByInvoiceId.length === 0
  ) {
    return null;
  }

  const sortedDisbursements = _.sortBy(
    invoiceDisbursementsData.getInvoiceDisbursementsByInvoiceId,
    (disbursement) => disbursement.capitalProviderOrganization.name,
  );

  return (
    <>
      <Typography fontWeight="bold">Cash Disbursement</Typography>

      <InvoiceDisbursementsTable
        disbursements={sortedDisbursements}
        invoiceReports={invoice.invoiceReports ?? undefined}
        creditFacilityId={invoice.creditFacilityId}
      />
    </>
  );
};
